import { NavLink, Outlet } from 'react-router-dom';

/**
 * Onboarding section shell with shared header and tab navigation.
 */
export function OnboardingPage() {
  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Onboarding</h1>
          <p style={styles.subtitle}>
            Manage the onboarding experience and review conversion performance.
          </p>
        </div>
      </div>

      <div style={styles.tabList}>
        <NavLink
          end
          to="editor"
          style={({ isActive }) => ({
            ...styles.tab,
            ...(isActive ? styles.tabActive : {}),
          })}
        >
          Editor
        </NavLink>
        <NavLink
          end
          to="analytics"
          style={({ isActive }) => ({
            ...styles.tab,
            ...(isActive ? styles.tabActive : {}),
          })}
        >
          Analytics
        </NavLink>
      </div>

      <div style={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
  },
  title: {
    margin: 0,
    fontSize: '34px',
    fontWeight: 600,
    color: '#1F1E1B',
    fontFamily: '"Sentient", Georgia, serif',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    margin: '8px 0 0 0',
    fontSize: '15px',
    color: '#6B645C',
    lineHeight: 1.6,
  },
  tabList: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    paddingBottom: '12px',
    borderBottom: '1px solid rgba(44,42,39,0.08)',
  },
  tab: {
    padding: '10px 16px',
    borderRadius: '999px',
    textDecoration: 'none',
    color: '#6B645C',
    fontSize: '14px',
    fontWeight: 600,
    background: 'rgba(44,42,39,0.04)',
    border: '1px solid transparent',
  },
  tabActive: {
    color: '#1F1E1B',
    background: '#F3EEE6',
    border: '1px solid rgba(201,187,168,0.65)',
    boxShadow: '0 1px 2px rgba(31,30,27,0.06)',
  },
  content: {
    minWidth: 0,
  },
};
